import { ProductsCategory } from '../../../../config';
export const variantOptions = [
  {
    id: 'k2',
    label: 'Vitamin D3 and K-2 2000 IU',
    productType: ProductsCategory.VITAMIN_D_K2,
  },
  {
    id: 'k5',
    label: 'Vitamin D3 and K-2 5000 IU',
    productType: ProductsCategory.VITAMIN_D_K5,
  },
];
